import { __assign } from "tslib";
export function createStylesParams(styles) {
    return Object.keys(styles).reduce(function (acc, key) {
        acc[key] = __assign(__assign({}, styles[key]), { key: styles[key].key || key });
        return acc;
    }, {});
}
//# sourceMappingURL=createStylesParams.js.map